module.exports = [
  {
    name: 'Cape TMF',
    type: 'tray',
    imgSrc: `${process.env.PUBLIC_URL}/assets/images/tray.png`,
  },
  {
    name: 'Cape BMF',
    type: 'bag',
    imgSrc: `${process.env.PUBLIC_URL}/assets/images/bag.png`,
  },
  {
    name: 'Cape PMF',
    type: 'pallet',
    imgSrc: `${process.env.PUBLIC_URL}/assets/images/pallet.png`,
  },
];
